export default "__VITE_ASSET__DaTVCd9f__ 584w";